// @flow
export type ActionType = 'USER/SET_LOGGED_IN';

type PayLoadType = {
    isLoggedIn: boolean
};

export type Action = {
    type: ActionType,
    payload: PayLoadType
};
export const USER_SET_LOGGED_IN = 'USER/SET_LOGGED_IN';

const ACTION_CREATORS = {
    setLoggedIn({isLoggedIn}: PayLoadType): Action {
        return {type: USER_SET_LOGGED_IN, payload: {isLoggedIn}};
    }
};

export default {
    ...ACTION_CREATORS
};
